import { SenderInformation } from 'components/SenderInformation/SenderInformation';
import { OFFER_ENTITY } from 'constants/offers';
import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getSectionsByEntitiesForIndia } from 'selectors/entities/sections/india/sections';
import { getSectionsByEntities } from 'selectors/entities/sections/sections';
import { getNonPrefillableFieldsForIndia } from 'selectors/ui/india/ui';
import { getNonPrefillableFields } from 'selectors/ui/ui';

const SenderInformationStep = ({
  isWizardIndia = false,
}: { isWizardIndia?: boolean }) => {
  const nonPrefillableFields = useSelector(
    isWizardIndia ? getNonPrefillableFieldsForIndia : getNonPrefillableFields,
  );
  const offerSection = useSelector((state: RootState) =>
    isWizardIndia
      ? getSectionsByEntitiesForIndia(state, [OFFER_ENTITY])
      : getSectionsByEntities(state, [OFFER_ENTITY]),
  )?.[0];

  return (
    <SenderInformation
      nonPrefillableFields={nonPrefillableFields}
      offerSection={offerSection}
    />
  );
};

export { SenderInformationStep };
